import { Modal } from '~components/Modals/Base';
import type { BenefitsModalProps } from '~features/benefits/model/types';

import { Content } from './dynamicContent';
import { modal, Spacer } from './styles';

export const BenefitsModal = (props: BenefitsModalProps) => {
	return (
		<Modal
			className={modal}
			open={props.open}
			locked={true}
			onClose={props.onCancel}
		>
			<Spacer />
			<Content {...props} />
			<Spacer />
		</Modal>
	);
};
